export enum EventCategories {
    CustomerEnablementAndEducation = 'Customer Enablement & Education',
    ProductSelector = 'Product Selector',
    UX = "UX"
}